import React from 'react';

import Row from 'components/Common/Row';
import Icon from 'kingpin/atoms/Icon';
import Typography from 'kingpin/atoms/Typography';

// A field's validation message, icon and text centred on one line and inset
// a little from the field.
const InlineFieldError = ({ message }: { message: string }) => (
  <Row centerAlign style={{ gap: 6, marginTop: 6, paddingLeft: 2 }}>
    <Icon
      icon={'warning'}
      color={'var(--color-status-error)'}
      width={14}
      height={14}
    />
    <Typography.Body type={'Body 12'} color={'var(--color-status-error)'}>
      {message}
    </Typography.Body>
  </Row>
);

export default InlineFieldError;
